// extracted by mini-css-extract-plugin
export default {"root":"_3Bvcn","upscaled-indicator":"_1ke0B","upscaledIndicator":"_1ke0B"};